import { useTheme } from '../theme/ThemeContext';

/**
 * Theme-aware Locksmith icon - the glyph-only mark, no wordmark.
 *
 * Use this anywhere the brand mark needs to fit inside a small
 * square (sidebar brand cell, avatar slot, etc.). The full
 * <Logo /> with wordmark would be illegible at <60px wide;
 * the icon is designed for it.
 *
 * Swaps src between locksmith-icon-dark-mode.png (used when
 * theme === 'dark', i.e. dark background) and the light-mode
 * variant (theme === 'light').
 *
 * Absolute path so Flask's /static handler serves it regardless
 * of the SPA's '/platform/' asset base.
 */
interface IconProps {
  /** Consumer styles the height; the component handles src. */
  className?: string;
  alt?: string;
}

export function Icon({ className, alt = 'Locksmith' }: IconProps) {
  const { theme } = useTheme();
  const src =
    theme === 'dark'
      ? '/static/img/locksmith-icon-dark-mode.png'
      : '/static/img/locksmith-icon-light-mode.png';
  return <img className={className} src={src} alt={alt} />;
}
